import { IGNORED_FACETS } from '@helpers/algolia/constants';
import getAlgoliaClientDefault from '@services/algolia/getAlgoliaClientDefault';

export default async function fetchIndexFacets(index: string): Promise<any> {
  const algoliaClient = getAlgoliaClientDefault();
  const searchIndex = algoliaClient.initIndex(index);
  const searchIndexSettings = await searchIndex.getSettings();

  return searchIndexSettings.attributesForFaceting.filter(
    (attribute: string) => !IGNORED_FACETS.includes(attribute)
  );
}
